import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import API from 'utils/api'
import { buildUrl, clamp } from 'utils/helpers'
import config from 'config'
import { clearDevices } from './devicesSlice'

export const fetchPayoutLicensedKeyInfos = createAsyncThunk(
  'payouts/fetchLicensedKeyInfos',
  async ({startDate, endDate, page = 0, limit = 10, kind, locality_uuid}, { getState, rejectWithValue, dispatch }) => {
    try {
      const setParams = () => {
        let params = []
        if (page) params.push(`page=${page + 1}`)
        if (limit) params.push(`limit=${limit}`)
        if (startDate) params.push(`start_date=${startDate}`)
        if (endDate) params.push(`end_date=${endDate}`)
        if (kind) params.push(`kind=${kind}`)
        if (locality_uuid) params.push(`locality_uuid=${locality_uuid}`)
        return params.join('&')
      }
      const infos = await API.request(
        buildUrl(`/payout/licensed_key_infos?${setParams()}`),
        {
          dispatch,
        },
        `${config.redirectUri}/api/v1`
      )
      return infos
    } catch {
      return rejectWithValue()
    }
  }
)

export const fetchPayoutLicensedKey = createAsyncThunk(
  'payouts/fetchLicensedKey',
  async ({startDate, endDate, page = 0, limit = 10, state}, { getState, rejectWithValue, dispatch }) => {
    try {
      const setParams = () => {
        let params = []
        if (page) params.push(`page=${page + 1}`)
        if (limit) params.push(`limit=${limit}`)
        if (startDate) params.push(`start_date=${startDate}`)
        if (endDate) params.push(`end_date=${endDate}`)
        if (state) params.push(`state=${state}`)
        return params.join('&')
      }
      const infos = await API.request(
        buildUrl(`/payout/licensed_keys?${setParams()}`),
        {
          dispatch,
        },
        `${config.redirectUri}/api/v1`
      )
      return infos
    } catch {
      return rejectWithValue()
    }
  }
)


// reducers
export const payoutSlice = createSlice({
  name: 'payouts',
  initialState: {
    payout_licensed_keys_info: null,
    payout_licensed_keys: null,
    page: 1,
    limit: 20,
  },
  reducers: {
    [clearDevices.type]: (state) => {
      state.payout_licensed_keys_info = []
      state.payout_licensed_keys = []
    },
    incPage: (state) => {
      state.page = clamp(state.page + 1, 1, state.pages)
    },
    decPage: (state) => {
      state.page = clamp(state.page - 1, 1, state.pages)
    },
  },
  extraReducers: {
    [fetchPayoutLicensedKeyInfos.fulfilled]: (state, { payload }) => {
      state.payout_licensed_keys_info = payload
    },
    [fetchPayoutLicensedKey.fulfilled]: (state, { payload }) => {
      state.payout_licensed_keys = payload
    },
  },
})

export const { incPage, decPage } = payoutSlice.actions

export default payoutSlice.reducer
